/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type {AccessTokenResponse} from '../models/AccessTokenResponse';
import type {UserResponse} from '../models/UserResponse';
import type {CancelablePromise} from '../core/CancelablePromise';
import type {BaseHttpRequest} from '../core/BaseHttpRequest';
export class AuthService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Initiates the WorkOS Hosted UI login flow and redirects the browser to the authorization URL,
   * reusing an existing refresh token when available.
   * @returns any OK
   * @throws ApiError
   */
  public authLogin({returnUrl}: {returnUrl?: string}): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/auth/login',
      query: {
        returnUrl: returnUrl,
      },
    });
  }
  /**
   * Handles the WorkOS authorization code callback, exchanges the code for tokens, enforces
   * organization membership, sets secure session cookies, and renders a browser bridge page.
   * @returns any OK
   * @throws ApiError
   */
  public authCallback({
    code,
    error,
    errorDescription,
    state,
  }: {
    code?: string;
    error?: string;
    errorDescription?: string;
    state?: string;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/auth/callback',
      query: {
        code: code,
        error: error,
        error_description: errorDescription,
        state: state,
      },
    });
  }
  /**
   * Revokes the WorkOS session and clears the authentication cookies. A POST that requires the CSRF
   * header, so another site cannot sign a user out; the SPA navigates away itself afterwards.
   * @returns void
   * @throws ApiError
   */
  public authLogout(): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/auth/logout',
    });
  }
  /**
   * Refreshes the WorkOS session using the refresh token cookie and reissues the access, refresh and
   * ResToken cookies on success. Requires the CSRF header;  calls the method
   * directly, which bypasses that filter, because it is a top-level navigation the browser makes itself.
   * @returns any OK
   * @throws ApiError
   */
  public authRefreshToken(): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/auth/refresh',
    });
  }
  /**
   * Returns the authenticated user's identifier and profile claims extracted from the validated
   * access token.
   * @returns UserResponse OK
   * @throws ApiError
   */
  public authGetCurrentUser(): CancelablePromise<UserResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/auth/user',
      errors: {
        401: `Unauthorized`,
      },
    });
  }
  /**
   * Retrieves the current access token from the HttpOnly cookie for use in API testing tools.
   * This endpoint is intended for development and testing purposes only and returns 404 in every
   * environment other than Development: a GET is exempt from the CSRF header rule, so exposing the
   * token here would let any script running on the page (XSS) read it despite the HttpOnly cookie.
   * The token has already been extracted from the cookie and validated by the authentication middleware.
   * @returns AccessTokenResponse OK
   * @throws ApiError
   */
  public authGetAccessToken(): CancelablePromise<AccessTokenResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/auth/token',
      errors: {
        401: `Unauthorized`,
        404: `Not Found`,
      },
    });
  }
  /**
   * Terminal endpoint invoked by WorkOS when authentication fails before reaching the callback,
   * returning the error details as a 400 response.
   * @returns void
   * @throws ApiError
   */
  public authLoginFailure({
    error,
    errorDescription,
  }: {
    error?: string;
    errorDescription?: string;
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/auth/login-failure',
      query: {
        error: error,
        error_description: errorDescription,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }
}
